<template>
    <div class="table"
        element-loading-background = "rgba(255, 255,255,0.7)"
        :element-loading-text = "loadingText"
        v-loading="loading">

        <el-input
            type="textarea"
            placeholder="课程表上"
            v-model="form.upCourse"
            maxlength="300"
            rows="8"
            show-word-limit>
        </el-input>
        <div>
            <div class="add-file-right" style="height:25px;">
                <span class="add-file-right-img" >上传文件：</span>
                <input type="file" ref="clearFile" @change="getUpFile($event)" class="add-file-right-input" accept="*">
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in upFileList" :key="index" style="list-style-type: none;">
                        <span>附件{{index+1}}.文件名：{{item.fileName}}</span><el-button type="text" @click="lookFile(item.fileUrl)" style="margin-left:20px;cursor:pointer;">查看</el-button><el-button type="text" @click="deleteFile(item.filePath)" style="margin-left:10px;cursor:pointer;color:red;">删除</el-button> 
                    </li>
                </ul>
            </div>
        </div>


        <el-divider></el-divider>
        
        <el-input
            type="textarea"
            placeholder="课程表下"
            v-model="form.downCourse"
            maxlength="300"
            rows="8"
            show-word-limit>
        </el-input>
        <div>
            <div class="add-file-right" style="height:25px;">
                <span class="add-file-right-img" >上传文件：</span>
                <input type="file" ref="clearFile" @change="getDownFile($event)" class="add-file-right-input" accept="*">
            </div>
            <div class="add-file-list">
                <ul>
                    <li v-for="(item, index) in downFileList" :key="index" style="list-style-type: none;">
                        <span>附件{{index+1}}.文件名：{{item.fileName}}</span><el-button type="text" @click="lookFile(item.fileUrl)" style="margin-left:20px;cursor:pointer;">查看</el-button><el-button type="text" @click="deleteFile(item.filePath)" style="margin-left:10px;cursor:pointer;color:red;">删除</el-button> 
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '../../../../../common/http';

    export default {
        data(){
            return{
                form:{
                    deptId:"",
                    upCourse:"",
                    downCourse:"",
                },
                uploadForm:new FormData(),
                uploadUrl:"",
                // 课程表上
                upFileList:[],
                // 课程表下
                downFileList:[],
                loading:false,
                loadingText:"",
            }
        },
        components: {
        },
        mounted:function () {
            this.uploadUrl=this.uploadIndexFileUrl;
            let deptId=sessionStorage.getItem("selectDeptId");
            this.form.deptId=deptId;
        },
        methods:{
            getUpFile(event){
                // console.log('上传文件下标：'+index);
                let file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    // 上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        
                        this.loading=true;
                        this.loadingText="上传中...";
                        this.uploadForm=new FormData(); 
                        // 上传文件
                        this.uploadForm.append('file', file[i]);
                        this.$axios.post(this.uploadUrl, this.uploadForm).then((res) => {
                            if(res.data.status == 200){
                                let f=res.data.data;
                                console.log(JSON.stringify(f));
                                this.upFileList.push(f);
                                this.$forceUpdate(); //强制更新
                                this.loading=false;
                            }else{
                                this.$commonFn.showTip(res.data.message, 3);
                                this.loading=false;
                            }
                        }, (err) => {
                            this.loading=false;
                            console.log(err)
                            this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3)
                        });
                    }else{
                        this.$commonFn.showTip('无法识别到该文件类型，请添加上扩展名',3);
                    }
                }
            },
            getDownFile(event){
                // console.log('上传文件下标：'+index);
                let file = event.target.files;
                for(var i = 0;i<file.length;i++){
                    // 上传类型判断
                    var imgName = file[i].name;
                    var idx = imgName.lastIndexOf(".");  
                    if (idx != -1){
                        this.loading=true;
                        this.loadingText="上传中...";
                        this.uploadForm=new FormData(); 
                        // 上传文件
                        this.uploadForm.append('file', file[i]);
                        this.$axios.post(this.uploadUrl, this.uploadForm).then((res) => {
                            if(res.data.status == 200){
                                let f=res.data.data;
                                console.log(JSON.stringify(f));
                                this.downFileList.push(f);
                                this.$forceUpdate(); //强制更新
                                this.loading=false;
                            }else{
                                this.$commonFn.showTip(res.data.message, 3);
                                this.loading=false;
                            }
                        }, (err) => {
                            this.loading=false;
                            console.log(err)
                            this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3)
                        });
                    }else{
                        this.$commonFn.showTip('无法识别到该文件类型，请添加上扩展名',3);
                    }
                }
            },
            // 删除文件
            deleteFile(filePath){
                // 删除课程表上文件
                for(let i=0;i<this.upFileList.length;i++){
                    let f=this.upFileList[i];
                    if(filePath == f.filePath){
                        this.upFileList.splice(i,1);
                    }
                }
                // 删除课程表下文件
                for(let i=0;i<this.downFileList.length;i++){
                    let f=this.downFileList[i];
                    if(filePath == f.filePath){
                        this.downFileList.splice(i,1);
                    }
                }
            },
            lookFile(url){
                window.open(url);
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/template/gkxq/Course.vue